import { gql } from 'graphql-tag';

export const companyGroupRelationshipsQuery = gql`
  query CompanyGroupRelationships($limit: Int, $cursor: String, $sourceCompanyId: String, $targetCompanyId: String) {
    companyRelationships(
      first: $limit
      after: $cursor
      sourceCompanyId: $sourceCompanyId
      targetCompanyId: $targetCompanyId
      relationshipType: COMPANY_GROUP
    ) {
      edges {
        node {
          companyRelationshipId
          sourceCompany {
            company_id
            company_name
            is_test
          }
          targetCompany {
            company_id
            company_name
            is_test
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const companyGroupPartnersQuery = gql`
  query CompanyGroupPartners(
    $limit: Int
    $cursor: String
    $targetCompanyId: String
    $relationshipType: CompanyRelationshipType
  ) {
    companyRelationships(
      first: $limit
      after: $cursor
      targetCompanyId: $targetCompanyId
      relationshipType: $relationshipType
    ) {
      edges {
        node {
          companyRelationshipId
          relationshipType
          sourceCompany {
            company_id
          }
          targetCompany {
            company_id
          }
          isCompanyGroupCopy
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
